module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5n1r2n-4adf46399291ff1bd54683c94bd8605a.svg";